export var CustomerChatProvider;
(function (CustomerChatProvider) {
    CustomerChatProvider["CHANNEL_TALK"] = "CHANNEL_TALK";
    CustomerChatProvider["MOBI_TALK"] = "MOBI_TALK";
    CustomerChatProvider["TWILIO"] = "TWILIO";
})(CustomerChatProvider || (CustomerChatProvider = {}));
